// extracted by mini-css-extract-plugin
module.exports = {"article-info-container":"Article_article-info-container__1Us7W","text-container":"Article_text-container__1os4p","image-container":"Article_image-container__sbPrs"};